import { connect } from "react-redux";
import * as Redux from "redux";
import {
  getFailedReports,
  getFailedReportsSuccess,
  resendReport,
  regenerateReport,
  regenerateSystemFailures
} from "../../actions";
import FailedReportList from "./component";

const mapStateToProps = (state: IAdminModuleState): IAdminModuleProps => {
  return {
    files: state.admin.files
  };
};

const mapDispatchToProps = (
  dispatch: Redux.Dispatch<any>
): IAdminModuleActions => {
  return {
    ...Redux.bindActionCreators(
      {
        getFailedReports,
        getFailedReportsSuccess,
        resendReport,
        regenerateReport,
        regenerateSystemFailures
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FailedReportList);



// WEBPACK FOOTER //
// ./client/modules/Admin/components/FailedReportList/container.ts